import { Signal, inject } from '@angular/core';
import { BaseNotifier, StateType } from '../notifiers/base-notifier';
import { Ref } from './ref';

export abstract class BaseProvider<N extends BaseNotifier<S>, S extends StateType> {
  protected readonly _notifier: N;
  protected readonly ref = inject(Ref);

  constructor(
    NotifierClass: new (ref: Ref, injector?: any) => N,
    injector?: any
  ) {
    this._notifier = new NotifierClass(this.ref, injector);
  }

  /**
   * Estado (readonly signal)
   */
  get state(): Signal<S> {
    return this._notifier.state;
  }



  /**
   * Notifier para métodos custom
   */
  get notifier(): N {
    return this._notifier;
  }
}
